import Vue from 'vue';
import Router from 'vue-router';
import store from './store'

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('./views/Home.vue'),
    },
    {
      path: '/avatars',
      name: 'avatars',
      component: () => import('./views/Avatars.vue'),
    },
    {
      path: '/carnet-de-bord',
      name: 'dashboard',
      component: () => import('./views/Dashboard.vue'),
    },
    {
      path: '/carnet-de-bord-soignant',
      name: 'dashboard-caregiver',
      component: () => import('./views/DashboardCaregiver.vue'),
      meta: {
        layout: 'dashboard'
      }
    },
    {
      path: '/carnet-de-bord-enfant',
      name: 'dashboard-child',
      component: () => import('./views/DashboardChild.vue'),
      meta: {
        layout: 'dashboard'
      }
    },
    {
      path: '/carnet-de-bord-enfant/:id',
      name: 'dashboard-child-preview',
      props: true,
      component: () => import('./views/DashboardChildPreview.vue'),
      meta: {
        layout: 'dashboard'
      }
    },
    {
      path: '/carnet-de-bord-proche',
      name: 'dashboard-relative',
      component: () => import('./views/DashboardRelative.vue'),
      meta: {
        layout: 'dashboard'
      }
    },
    {
      path: '/carnet-de-bord-parent',
      name: 'dashboard-parent',
      component: () => import('./views/DashboardParent.vue'),
      meta: {
        layout: 'dashboard'
      }
    },
    {
      path: '/a-propos',
      name: 'about',
      component: () => import('./views/About.vue'),
    },
    {
      path: '/sondage/:id',
      name: 'sondage',
      props: true,
      component: () => import('./views/Sondage.vue'),
    },
    {
      path: '/partenaires',
      name: 'partenaires',
      component: () => import('./views/Partenaires.vue'),
    },
    {
      path: '/suivez-nous',
      name: 'follow_us',
      component: () => import('./views/FollowUs.vue'),
    },
    {
      path: '/soutenez-nous',
      name: 'support_us',
      component: () => import('./views/SupportUs.vue'),
    },
    {
      path: '/contactez-nous',
      name: 'contact_us',
      component: () => import('./views/ContactUs.vue'),
    },
    {
      path: '/concept',
      name: 'concept',
      component: () => import('./views/Concept.vue'),
    },
    {
      path: '/jeu-fil-rouge',
      name: 'fil_rouge',
      component: () => import('./views/FilRouge.vue'),
    },
    {
      path: '/faq',
      name: 'faq',
      component: () => import('./views/Faq.vue'),
    },
    {
      path: '/mentions-legales',
      name: 'mentions_legales',
      component: () => import('./views/MentionsLegales.vue'),
    },
    {
      path: '/cgu',
      name: 'cgu',
      component: () => import('./views/Cgu.vue'),
    },
    {
      path: '/inscription',
      name: 'signup',
      component: () => import('./views/SignUp.vue'),
      meta: {
        guest: true
      }
    },
    {
      path: '/gerer-mon-compte',
      name: 'edit_my_account',
      component: () => import('./views/Edit.vue')
    },
    {
      path: '/gerer-mon-compte-soignant',
      name: 'edit_account_caregiver',
      component: () => import('./views/EditCaregiver.vue')
    },
    {
      path: '/inscription-soignant',
      name: 'signupCaregiver',
      component: () => import('./views/SignUpCaregiver.vue'),
	  meta: {
        guest: true
      }
    },
    {
      path: '/invitation-enfant',
      name: 'invite-child-caregiver',
      component: () => import('./views/InviteChildCaregiver.vue'),
	    meta: {
        layout: 'dashboard'
      }
    },
    {
      path: '/inscription-enfant',
      name: 'signupChild',
      component: () => import('./views/SignUpChild.vue')
    },
    {
      path: '/inscription-compte',
      name: 'signupsub',
      component: () => import('./views/SignUpSub.vue')
    },
    {
      path: '/mini-jeux',
      name: 'games',
      component: () => import('./views/Games.vue'),
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/mini-jeux/myelogramme/:gameId',
      name: 'gamemyelogramme',
      component: () => import('./views/games/myelogramme.vue'),
      props: true,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/mini-jeux/transfusion/:gameId',
      name: 'gametransfusion',
      component: () => import('./views/games/transfusion.vue'),
      props: true,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/mini-jeux/chimiotherapie/:gameId',
      name: 'gamechimio',
      component: () => import('./views/games/chimiotherapie.vue'),
      props: true,
    },
    {
      path: '/mini-jeux/decouverte/:gameId',
      name: 'gamedecouverte',
      component: () => import('./views/games/decouverte.vue'),
      props: true,
    },
    {
      path: '/mini-jeux/catheter/:gameId',
      name: 'gamecatheter',
      component: () => import('./views/games/catheter.vue'),
      props: true,
    },
    {
      path: '/mini-jeux/voie-veineuse/:gameId',
      name: 'gamevoie-veineuse',
      component: () => import('./views/games/voie-veineuse.vue'),
      props: true,
    },
    {
      path: '/mini-jeux/conditionnement/:gameId',
      name: 'gameconditionnement',
      component: () => import('./views/games/conditionnement.vue'),
      props: true,
    },
    {
      path: '/mini-jeux/chimiotherapie-mobile/',
      name: 'gamechimiomobile',
      component: () => import('./views/games/chimiotherapie-mobile.vue'),
      props: true,
    },
    {
      path: '/notifications',
      name: 'notifications',
      component: () => import('./views/Notifications.vue'),
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/agenda',
      name: 'agenda',
      component: () => import('./views/Agenda.vue'),
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/bibliotheque',
      name: 'fiches_medicales',
      component: () => import('./views/FichesMedicales.vue'),
    },
    {
      path: '/fiches-medicales/:id',
      name: 'fiche_medicale',
      component: () => import('./views/FicheMedicale.vue'),
    },
    {
      path: '/404',
      name: '404',
      component: () => import('./views/404.vue'),
    },
    {
      path: '/401',
      name: '401',
      component: () => import('./views/401.vue'),
    },
    {
      path: '/editer-profil/:id',
      name: 'edit-sub',
      props: true,
      component: () => import('./views/EditSub.vue'),
    },
    {
      path: '/editer-son-avatar',
      name: 'EditAvatar',
      component: () => import('./views/EditAvatar.vue'),
    },
    {
      path: '/mot-de-passe-oublie',
      name: 'lost-password',
      component: () => import('./views/LostPassword.vue'),
    },
    {
      path: '/nouveau-mot-de-passe/:token',
      name: 'new-password',
      props: true,
      component: () => import('./views/NewPassword.vue'),
    },
    {
      path: '/tutoriel',
      name: 'tutoriel',
      component: () => import('./views/Tutoriel.vue'),
    },
    {
      path: '/suggestion',
      name: 'suggestion',
      component: () => import('./views/Suggestion.vue'),
    },
    {
      path: '/date',
      name: 'Date',
      component: () => import('./views/Date.vue'),
    },
    {
      path: '/liste-des-soignants',
      name: 'indexCaregiver',
      component: () => import('./views/IndexCaregiver.vue'),
    },
    {
      path: '/liste-des-sous-comptes',
      name: 'indexSub',
      component: () => import('./views/IndexSub.vue'),
    },
    {
      path: '/inscription-soignant-reussie',
      name: 'PostSignUpCaregiver',
      component: () => import('./views/PostSignUpCaregiver.vue'),
    },
    {
      path: '/inscription-reussie',
      name: 'PostSignUp',
      component: () => import('./views/PostSignUp.vue'),
    },
    {
      path: '/inscription-proche-reussie',
      name: 'PostSignUpRelative',
      component: () => import('./views/PostSignUpRelative.vue'),
    },
    {
      path: '/inscription-enfant-reussie',
      name: 'post_child_sign_up',
      component: () => import('./views/PostSignUpChild.vue'),
    },
    {
      path: '/inscription-proche-reussie',
      name: 'post_sub_sign_up',
      component: () => import('./views/PostSignUpSub.vue'),
    },
    {
      path: '/premiere-connexion',
      name: 'PostFirstSignIn',
      component: () => import('./views/PostFirstSignIn.vue'),
    },
    {
      path: '/ticket-inscription',
      name: 'CardRegister',
      component: () => import('./views/CardRegister.vue'),
    },
  ],
})

export default router
